import React, { useState, Fragment, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button, Input,
    Row, Label,
    CustomInput
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { API_Ingetration } from '../../../../../../constants/APIs';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';

export default function HelpCenterGroupEngagedUrl({ integrationProperties, properties, botSettings, saveIntegration }) {
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings.engegedProperties !== null &&
        !botSettings.engegedProperties.disabled
    );
    const [propertyList, setPropertyList] = useState([]);
    const [integrationList, setIntegrationList] = useState([]);
    const [inputData, setInputData] = useState({
        disabled: true,
        engagedPropertyUrls: []
    });
    useEffect(() => {
        let body = {
            channels: ['WebsiteDirectLine']
        };
        AxiosAPI({
            method: 'post',
            url: `${API_Ingetration}?group_id=${getGroupID()}`,
            data: body
        }).then((res) => {
            const webIntegrationData = res.data.filter(
                (k) => k.channel === 'WebsiteDirectLine' && k.disabled === false
            );
            setIntegrationList(webIntegrationData);
        });
        if (integrationProperties !== null && integrationProperties.length > 0) {
            var property = [];
            properties.filter((p) => integrationProperties.includes(p.id))
                .map(m => {
                    property.push({ id: m.id, name: m.name, url: "", checked: false });
                });
            if (botSettings !== undefined && botSettings.engegedProperties !== null) {
                setInputData({
                    ...botSettings.engegedProperties,
                    disabled: botSettings.engegedProperties.disabled,
                    engagedPropertyUrls: botSettings.engegedProperties.engagedPropertyUrls !== null ?
                        botSettings.engegedProperties.engagedPropertyUrls : []
                });
                if (botSettings.engegedProperties.engagedPropertyUrls !== null && botSettings.engegedProperties.engagedPropertyUrls.length > 0) {
                    property = property.map(p => {
                        var ext = botSettings.engegedProperties.engagedPropertyUrls.filter(e => e.id === p.id);
                        if (ext.length > 0) {
                            p.url = ext[0].url;
                            p.checked = true;
                            p.integrationId = ext[0].integrationId
                        }
                        return p;
                    });
                }
            }
            property.sort(function (a, b) {
                if (a.name < b.name) { return -1; } if (a.name > b.name) { return 1; } return 0;
            });
            setPropertyList(property.sort((a, b) => a.name - b.name));
        }
    }, [integrationProperties, botSettings]);

    const handleChange = (e) => {
        const values = propertyList.map((elem) => {
            if (elem.id === e.target.name) {
                elem.url = e.target.value;
            }
            return {
                ...elem,
            };
        });
        setPropertyList(values);
        var urldata = [];
        values.filter(k => k.checked === true).map(t => {
            urldata.push({
                id: t.id,
                url: t.url,
                integrationId: t.integrationId
            })
        });
        setInputData({ ...inputData, engagedPropertyUrls: urldata });
    }

    const handleChangeIntegration = (e) => {
        const values = propertyList.map((elem) => {
            if (elem.id === e.target.name) {
                elem.integrationId = e.target.value;
            }
            return {
                ...elem,
            };
        });
        setPropertyList(values);
        var urldata = [];
        values.filter(k => k.checked === true).map(t => {
            urldata.push({
                id: t.id,
                url: t.url,
                integrationId: t.integrationId
            })
        });
        setInputData({ ...inputData, engagedPropertyUrls: urldata });
    }
    const handleRoleChange = (e) => {
        const values = propertyList.map((elem) => {
            if (elem.id === e.target.value) {
                if (elem.checked) {
                    elem.checked = false;
                } else if (!elem.checked) {
                    elem.checked = true;
                }
            }
            return {
                ...elem,
            };
        });
        setPropertyList(values);
        var urldata = [];
        values.filter(k => k.checked === true).map(t => {
            urldata.push({
                id: t.id,
                url: t.url
            })
        });
        setInputData({ ...inputData, engagedPropertyUrls: urldata });
    }
    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setInputData({
            ...inputData,
            disabled: !value
        });
    };
    const handleSave = () => {
        let setting = botSettings;
        setting.engegedProperties = inputData;
        saveIntegration({
            botSetting: setting
        });
    };
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>Property Pages</h6>
                </div>
                <Separator className="mb-3" />
                <Row>
                    <Colxx md={12} className='mt-2'>
                        <div className="d-flex w-100">
                            <Label>Enabled</Label>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={checkedPrimarySmall}
                                onChange={(primary) => handleSwitchChange(primary)}
                            />
                        </div>
                    </Colxx>
                    <Colxx md={12} className='mt-2'>
                        <p>Specify web URL’s for each property</p>
                        <div className="mb-2 mt-4">
                            {propertyList.length > 0 && propertyList.map((elem, i) => (
                                <Row key={i}>
                                    <Colxx xxs="6" className="mt-1">
                                        <CustomInput
                                            key={`buttonChk~${i}`}
                                            type="checkbox"
                                            value={elem.id}
                                            id={elem.id}
                                            onChange={(e) => handleRoleChange(e)}
                                            checked={elem.checked}
                                        >
                                            {elem.name}
                                        </CustomInput>
                                    </Colxx>
                                    <Colxx xxs="6" className="mt-1">
                                        <Row>
                                            {elem.checked ? (
                                                <Colxx xxs="12" className="mt-1">
                                                    <Input
                                                        key={`buttontText~${i}`}
                                                        type="textarea"
                                                        value={elem.url}
                                                        name={elem.id}
                                                        placeholder={"Enter Url"}
                                                        onChange={handleChange}
                                                    />
                                                </Colxx>
                                            ) : null}
                                            {elem.checked ? (
                                                <Colxx xxs="12" className="mt-1">
                                                    <div className="mb-2">
                                                        <Input
                                                            type="select"
                                                            name={elem.id}
                                                            value={elem.integrationId}
                                                            onChange={(e) => handleChangeIntegration(e)}
                                                        >
                                                            <option value={""}>Select Chatbot to Integrate</option>
                                                            {integrationList.filter(k => k.properties.includes(elem.id)).map((item, i) => (
                                                                <option value={item.id} key={i}>
                                                                    {item.name === null || item.name === "" ? item.botSettings.name : item.name + " - " + item.botSettings.name}
                                                                </option>
                                                            ))}

                                                        </Input>
                                                    </div>
                                                </Colxx>
                                            ) : null}
                                        </Row>
                                    </Colxx>
                                </Row>
                            ))}
                        </div>
                    </Colxx>
                    <Colxx md={12} className="mt-2">
                        <div className="mb-1 mt-4 ml-2">
                            <Button
                                color="success"
                                size="xs"
                                className="mt-1"
                                onClick={() => handleSave()}
                            >
                                Save
                            </Button>
                        </div>
                    </Colxx>
                </Row>
            </CardBody>
        </Card>
    );

}